module.exports = __webpack_public_path__ + "14880b697dc55690fcf8f97c7e0d0122.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-768.webp
// module id = 208
// module chunks = 0